import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useSetAtom } from 'jotai';
import defaultValue from './defaultValue';
import favoriteModalStateAtom from './favoriteModalStateAtom';
const useResetFavoriteModalState = () => {
  const $ = _c(2);
  const setFavoriteModalState = useSetAtom(favoriteModalStateAtom);
  let t0;
  if ($[0] !== setFavoriteModalState) {
    t0 = () => {
      setFavoriteModalState(defaultValue);
    };
    $[0] = setFavoriteModalState;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const resetFavoriteModalState = t0;
  return resetFavoriteModalState;
};
export default useResetFavoriteModalState;